import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Trans } from 'react-i18next';

interface FeatureListProps {
  features: string[];
  boldCount?: number;
}

const FeatureList: React.FC<FeatureListProps> = ({ features, boldCount = 0 }) => (
  <ul className='featureList'>
    {features?.map((feature, index) => (
      <li key={feature} className={`featureItem ${index < boldCount ? 'bold' : ''}`}>
        <CheckCircleIcon className='featureIcon' color='success' />
        <span className='featureText'>
          <Trans
            i18nKey={feature}
            components={{
              strong: <strong />,
            }}
          />
        </span>
      </li>
    ))}
  </ul>
);

export default FeatureList;
